import { render, staticRenderFns } from "./ConfiguracoesPage.vue?vue&type=template&id=a8c80854&scoped=true"
import script from "./ConfiguracoesPage.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesPage.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesPage.vue?vue&type=style&index=0&id=a8c80854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c80854",
  null
  
)

export default component.exports